<ng-container *ngFor="let itinerary of optionPlan.itineraries;index as idx">
    <div class="itinerary-banner" [class.selected]="idx === indexSelected()" (click)="selectItinerary(itinerary, idx)">
        <div class="itinerary-transport-row">
            <app-leg-banner [legs]="itinerary.legs"></app-leg-banner>
        </div>
        <div class="itinerary-time-row">
            <div class="time-distance-container">
                <div class="time">
                    <mat-icon class="time-icon">hourglass_empty</mat-icon>
                    <span class="time-label">{{ (itinerary.startTime | date:'HH:mm') }} - {{ (itinerary.endTime|
                        date:'HH:mm') }}</span>
                </div>
                <div class="time">
                    <mat-icon class="time-icon" svgIcon="distance"></mat-icon>
                    <span class="time-label">{{ itinerary.distance | number:'1.0-0' }} {{'routeResults.meters' |
                        transloco}}</span>
                </div>
            </div>
            <span class="itinerary-duration">
                <span [appShowDuration]="itinerary.duration"></span>
                - <span class="itinerary-duration-time">{{(itinerary.endTime | date:'HH:mm')}}h</span>
            </span>

        </div>
    </div>
</ng-container>